import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QRCodeCanvas } from 'qrcode.react';

import UtilService from '../../services/Celcoin/utilService';
import { getTranslations } from '../../services/languageUtils';

class SecuritySetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      translations: {},
      otpauthUrl: '',
      setupCode: '',
      loadingSetup: false,
      step: 'generate',
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
    
    const tempUserData = sessionStorage.getItem('tempUserData');
    if (!tempUserData) {
      window.location.href = '/login';
      return;
    }

    this.generateQRCode();
  }

  toastMessage = (type, message) => {
    return toast(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: type,
      theme: "light"
    });
  }

  generateQRCode = async () => {
    this.setState({ loadingSetup: true });
    
    try {
      const email = sessionStorage.getItem('tempUserEmail');
      const password = sessionStorage.getItem('tempPassword');
      
      const response = await UtilService.createMFA(email, password);
      
      this.setState({
        otpauthUrl: response.otpauthUrl,
        loadingSetup: false,
        step: 'confirm'
      });
    } catch (error) {
      this.setState({ loadingSetup: false });
      this.toastMessage('error', 'Erro ao gerar código 2FA. Tente novamente.');
    }
  }

  confirmSetup2FA = async () => {
    if (this.state.setupCode.length !== 6) {
      return this.toastMessage('error', 'Digite o código de 6 dígitos');
    }

    this.setState({ loadingSetup: true });

    try {
      const email = sessionStorage.getItem('tempUserEmail');
      const password = sessionStorage.getItem('tempPassword');

      await UtilService.verifyMFASetup(email, this.state.setupCode);
      
      await UtilService.completeLogin(email, password);
      
    } catch (error) {
      this.setState({ loadingSetup: false });
      this.toastMessage('error', 'Código inválido. Tente novamente.');
    }
  }

  render() {
    return (
      <section className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <img 
              src={require("../../assets/imgs/ico-higher-bg.svg").default} 
              alt="Higher Logo" 
              className="h-12 w-auto"
            />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Configure sua segurança
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Para continuar, configure a autenticação de dois fatores
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            
            {this.state.loadingSetup ? (
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto"></div>
                <p className="mt-4 text-gray-600">Gerando código de segurança...</p>
              </div>
            ) : (
              <>
                {this.state.step === 'confirm' && this.state.otpauthUrl && (
                  <div className="space-y-6">
                    
                    <div className="text-center">
                      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm font-medium text-blue-800">
                              Como configurar:
                            </h3>
                            <div className="mt-2 text-sm text-blue-700">
                              <ol className="list-decimal list-inside space-y-1">
                                <li>Baixe um app autenticador (Google Authenticator, Authy)</li>
                                <li>Escaneie o código QR abaixo</li>
                                <li>Digite o código de 6 dígitos gerado</li>
                              </ol>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-center">
                      <div className="p-4 bg-white border-2 border-gray-200 rounded-lg">
                        <QRCodeCanvas 
                          value={this.state.otpauthUrl} 
                          size={200}
                          level="M"
                          includeMargin={true}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 text-center mb-2">
                        Digite o código de 6 dígitos
                      </label>
                      <input
                        type="text"
                        maxLength={6}
                        value={this.state.setupCode}
                        onChange={(e) => this.setState({
                          setupCode: e.target.value.replace(/\D/g, '').substring(0, 6)
                        })}
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500 text-center text-lg tracking-widest font-mono"
                        placeholder="000000"
                      />
                    </div>

                    <div>
                      <button
                        onClick={() => this.confirmSetup2FA()}
                        disabled={this.state.setupCode.length !== 6 || this.state.loadingSetup}
                        className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
                          this.state.setupCode.length === 6 && !this.state.loadingSetup
                            ? 'bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                            : 'bg-gray-300 cursor-not-allowed'
                        }`}
                      >
                        {this.state.loadingSetup ? (
                          <div className="flex items-center">
                            <div className="animate-spin -ml-1 mr-3 h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                            Configurando...
                          </div>
                        ) : (
                          'Ativar 2FA e Continuar'
                        )}
                      </button>
                    </div>

                    <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-yellow-800">
                            Importante
                          </h3>
                          <div className="mt-2 text-sm text-yellow-700">
                            <p>Esta configuração é obrigatória para a segurança da sua conta bancária.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <ToastContainer />
      </section>
    );
  }
}

export default SecuritySetup;